import subscribeToNotificationOpx from './subscribeToNotificationOpx';
import { applyOptions } from '../actions/activityFeedApplyOptions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { initializeFileTypeIcons } from '@fluentui/react-file-type-icons';
import { loadActivityFeedSettings } from './loadActivityFeedSettings';
import { promptUpdateHost } from '../actions/promptUpdateHost';
import { registerForPromptUpdateHost, updateHost } from 'owa-client-pie/lib/system.g';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getActivityFeedStore } from '../store/store';
import { logUsage } from 'owa-analytics';

initializeFileTypeIcons();

export interface InitializeActivityFeedParameters {
    isOpx?: boolean;
}

export function initializeActivityFeed(params?: InitializeActivityFeedParameters) {
    var isOpx = params?.isOpx ?? false;
    getActivityFeedStore().isOpx = isOpx;
    if (isFeatureEnabled('auth-activityFeed')) {
        applyOptions();
        loadActivityFeedSettings(true /* doLoadActivityFeed */);
        if (isFeatureEnabled('auth-activityFeedPrimeNotification')) {
            subscribeToNotificationOpx(isOpx);
        }

        // If running in native host, register for the prompt update host PIE event
        if (isHostAppFeatureEnabled('promptRebootNativeHost')) {
            logUsage('RegisterForPromptUpdateHost');
            registerForPromptUpdateHost(() => {
                const rebootHostCallback = () => {
                    updateHost(/*forceUpdate*/ false);
                };
                promptUpdateHost(rebootHostCallback);
            });
        }
    }
}
